import React from "react";

const FetchImage = ({ image, className }) => {
  return (
    <>
      <img src={process.env.GATSBY_IMAGE_URL + image} className={className ? className : ""} alt="fetchImage" />
    </>
  );
};

export default FetchImage;
